export default (state, postList) => {
    state.postList = postList
}
